import React, { useEffect, useState } from 'react';
import Box from '@material-ui/core/Box';
import NavHead from './NavHead';
import useStyles from './styles';
import Sidebar from './SideBar';
import CssBaseline from '@material-ui/core/CssBaseline';
import clsx from 'clsx';
import { useMediaQuery } from '@material-ui/core';
import { Theme } from '@material-ui/core/styles';

export const drawerWidth = 240;

interface LayoutProps {
  firstName: string;
  children: any;
}

const Layout = (props: LayoutProps) => {
  const classes = useStyles();
  const { children } = props;

  const isMobile = useMediaQuery((theme: Theme) =>
    theme.breakpoints.down('md'),
  );

  const [drawerOpened, setDrawerOpened] = useState<boolean>(false);

  useEffect(() => setDrawerOpened(!isMobile), [isMobile]);

  return (
    <Box display="flex">
      <CssBaseline />
      <NavHead
        drawerOpened={drawerOpened}
        onOpenDrawer={() => setDrawerOpened(true)}
      />
      <Sidebar
        drawerOpened={drawerOpened}
        onCloseDrawer={() => setDrawerOpened(false)}
      />
      <main
        className={clsx(classes.content, {
          [classes.contentUnshift]: !isMobile,
          [classes.contentShift]: !isMobile && drawerOpened,
        })}>
        {children}
      </main>
    </Box>
  );
};

export default Layout;
